import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

export interface FileMeaningsInterface {
    formVisible: boolean;
    formVariant: "new" | "edit";
    editId: string;
    editTitle: string;
    editAlias: string;
    editActive: boolean;
    deleteStatusModalVisible: boolean;
    deleteId?: string;
    editFileExtensionsModalVisible: boolean;
    editFileExtensionsId?: string;
}

function getInitialState(): FileMeaningsInterface {
    return {
        formVisible: false,
        formVariant: "new",
        editId: "",
        editTitle: "",
        editAlias: "",
        editActive: true,
        deleteStatusModalVisible: false,
        editFileExtensionsModalVisible: false,
    };
}

export const FileMeaningsSlice = createSlice({
    name: "FileMeaningsSlice",
    initialState: getInitialState(),
    reducers: {
        reset: () => getInitialState(),
        updateFields: (
          state: FileMeaningsInterface,
          action: PayloadAction<Partial<FileMeaningsInterface>>
        ) => {
            Object.assign(state, action.payload);
        },

    },

});

export const {updateFields, reset} = FileMeaningsSlice.actions;

export const FileMeaningsSelectors = {
    formVisible: (state: RootState) => state.fileMeanings.formVisible,
    formVariant: (state: RootState) => state.fileMeanings.formVariant,
    editId: (state: RootState) => state.fileMeanings.editId,
    editTitle: (state: RootState) => state.fileMeanings.editTitle,
    editAlias: (state: RootState) => state.fileMeanings.editAlias,
    editActive: (state: RootState) => state.fileMeanings.editActive,
    deleteModalVisible: (state: RootState) => state.fileMeanings.deleteStatusModalVisible,
    deleteId: (state: RootState) => state.fileMeanings.deleteId,
    editFileExtensionsModalVisible: (state: RootState) => state.fileMeanings.editFileExtensionsModalVisible,
    editFileExtensionsId: (state: RootState) => state.fileMeanings.editFileExtensionsId,
};

export const FileMeaningsReducer = FileMeaningsSlice.reducer;
